import { render } from "./SysWechatDialog.vue?vue&type=template&id=88cf557a&scoped=true"
import script from "./SysWechatDialog.vue?vue&type=script&lang=js"
export * from "./SysWechatDialog.vue?vue&type=script&lang=js"

import "./SysWechatDialog.vue?vue&type=style&index=0&id=88cf557a&scoped=true&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88cf557a"]])

export default __exports__